export const GET_SINGLE_PRODUCT = 'singleProduct/GET_SINGLE_PRODUCT';
export const GET_SINGLE_PRODUCT_SUCCESS =
  'singleProduct/GET_SINGLE_PRODUCT_SUCCESS';
export const GET_SINGLE_PRODUCT_ERROR =
  'singleProduct/GET_SINGLE_PRODUCT_ERROR';
export const RESET_SINGLE_PRODUCT = 'singleProduct/RESET_SINGLE_PRODUCT';
